import Vue from 'vue';
// import moment from 'moment';
import state from '@/store/state';

const moment = require('moment-timezone');

/**
 * Return translations key value if had, or return key it self
 * @param key {string}
 * @returns {*}
 */
const translate = key => state.translations[key] || key;

// Trasnlate
Vue.filter('translate', translate);

/**
 * Format to proper date
 */
const momentFormat = (value, format, timezone) => moment.tz(value, timezone).format(format);
// Date format
Vue.filter('momentFormat', momentFormat);

export {
  translate,
  momentFormat,
};
